class ObserverFactory {
  _clearListeners() {
    return this.listeners = {};
  }

  on(eventNames, listener) {
    for (let eventName of eventNames.split(' ')) {
      if (this.listeners == null) { this.listeners = {}; }
      if (this.listeners[eventName] == null) { this.listeners[eventName] = []; }
      this.listeners[eventName].push(listener);
    }

    return () => this.off(eventNames, listener);
  }

  once(eventNames, listener) {
    listener.__once__ = true;
    return this.on(eventNames, listener);
  }

  off(eventNames, listener) {
    for (let eventName of eventNames.split(' ')) {
      if (!this.listeners || !this.listeners[eventName]) {
        continue;
      }

      let i = this.listeners[eventName].indexOf(listener);
      if (i !== -1) {
        this.listeners[eventName].splice(i, 1);
      }
    }
  }

  emit(eventName, ...params) {
    if (!this.listeners || !this.listeners[eventName]) {
      return;
    }

    this.listeners[eventName].concat([]).forEach((listener) => {
      listener.apply(this, params);

      if (listener.__once__) {
        item = this.off(eventName, listener);
      }
    });
  }
};

st.ObserverFactory = ObserverFactory;



// WEBPACK FOOTER //
// ./app/webpack/frontend/common/ObserverFactory.js